const axios = require('axios')

export default class Users {
    getAlertsCount() {
        return axios.get('/alerts/count')
    }
}